import React, { Fragment } from "react";
import { Controller, useForm } from "react-hook-form";
import { NotificationSettings } from "../../../../core/api/models";
import ErrorMessage from "../../../../components/text/ErrorMessage";
import { DropdownList, Multiselect } from "react-widgets";
import {
  AccountType,
  convertPascalCaseToWords,
  ITemplateKeyItem,
} from "../../../../core";

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: NotificationSettings) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: NotificationSettings;
  error?: string;
  templates: ITemplateKeyItem[];
  events: ITemplateKeyItem[];
}> = (props) => {
  const {
    control,
    handleSubmit,
    errors,
    watch,
  } = useForm<NotificationSettings>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });

  const renderSmsEnabledTemplates = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">
          SMS Enabled Templates<span className="text-danger">*</span>
        </label>
        <div className="row">
          <div className="col-12">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                rules={{
                  required: true,
                  validate: (value) => {
                    return !!(value.length > 0);
                  },
                }}
                name="smsEnabledTemplates"
                defaultValue={props.data?.smsEnabledTemplates}
                render={({ onChange, value, name }) => (
                  <Multiselect
                    value={value}
                    data={props.templates}
                    defaultValue={value}
                    textField={"name"}
                    valueField={"key"}
                    placeholder={"Select Templates"}
                    onChange={(val) => {
                      onChange(val?.map((x) => x.key));
                    }}
                    allowCreate="onFilter"
                    autoFocus={true}
                  />
                )}
              />
              {errors.smsEnabledTemplates && (
                <ErrorMessage>Templates is required</ErrorMessage>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };
  const renderAppNotificationEnabledTemplates = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">
          App Notification Enabled Templates
          <span className="text-danger">*</span>
        </label>
        <div className="row">
          <div className="col-12">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                rules={{
                  required: true,
                  validate: (value) => {
                    return !!(value.length > 0);
                  },
                }}
                name="appNotificationEnabledTemplates"
                defaultValue={props.data?.appNotificationEnabledTemplates}
                render={({ onChange, value, name }) => (
                  <Multiselect
                    value={value}
                    data={props.templates}
                    defaultValue={value}
                    textField={"name"}
                    valueField={"key"}
                    placeholder={"Select Templates"}
                    onChange={(val) => {
                      onChange(val?.map((x) => x.key));
                    }}
                    allowCreate="onFilter"
                    autoFocus={true}
                  />
                )}
              />
              {errors.appNotificationEnabledTemplates && (
                <ErrorMessage> Templates is required</ErrorMessage>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderEmailEnabledTemplates = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">
          Email Enabled Templates<span className="text-danger">*</span>
        </label>
        <div className="row">
          <div className="col-12">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                rules={{
                  required: true,
                  validate: (value) => {
                    return !!(value.length > 0);
                  },
                }}
                name="emailEnabledTemplates"
                defaultValue={props.data?.emailEnabledTemplates}
                render={({ onChange, value, name }) => (
                  <Multiselect
                    value={value}
                    data={props.templates}
                    defaultValue={value}
                    textField={"name"}
                    valueField={"key"}
                    placeholder={"Select Templates"}
                    onChange={(val) => {
                      onChange(val?.map((x) => x.key));
                    }}
                    allowCreate="onFilter"
                    autoFocus={true}
                  />
                )}
              />
              {errors.emailEnabledTemplates && (
                <ErrorMessage>Templates is required</ErrorMessage>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderCcEnabledEvents = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">
          {" "}
          Cc Enabled Events<span className="text-danger">*</span>
        </label>
        <div className="row">
          <div className="col-12">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                rules={{
                  required: true,
                  validate: (value) => {
                    return !!(value.length > 0);
                  },
                }}
                name="ccEnabledEvents"
                defaultValue={props.data?.ccEnabledEvents}
                render={({ onChange, value, name }) => (
                  <Multiselect
                    value={value}
                    data={props.events}
                    defaultValue={value}
                    textField={"name"}
                    valueField={"key"}
                    placeholder={"Select Events"}
                    onChange={(val) => {
                      onChange(val?.map((x) => x.key));
                    }}
                    allowCreate="onFilter"
                    autoFocus={true}
                  />
                )}
              />
              {errors.ccEnabledEvents && (
                <ErrorMessage>Events is required</ErrorMessage>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderEnableCCEmailToCrmAgentForAssignSalesPerson = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <Controller
            control={control}
            name="enableCCEmailToCrmAgentForAssignSalesPerson"
            defaultValue={
              props.data?.enableCCEmailToCrmAgentForAssignSalesPerson
            }
            render={({ onChange, value, name }) => (
              <Fragment>
                <input
                  type="checkbox"
                  id={name}
                  checked={value}
                  onChange={(e) => onChange(e.target.checked)}
                />
                <label htmlFor={name}>
                  Enable Email To Support Executive For Assign
                  SalesPerson?
                </label>
              </Fragment>
            )}
          />
          <ErrorMessage>
            {errors.enableCCEmailToCrmAgentForAssignSalesPerson?.message}
          </ErrorMessage>
        </div>
      </div>
    );
  };

  const renderEnableCCEmailToCrmAgentForTestDrive = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <Controller
            control={control}
            name="enableCCEmailToCrmAgentForTestDrive"
            defaultValue={props.data?.enableCCEmailToCrmAgentForTestDrive}
            render={({ onChange, value, name }) => (
              <Fragment>
                <input
                  type="checkbox"
                  id={name}
                  checked={value}
                  onChange={(e) => onChange(e.target.checked)}
                />
                <label htmlFor={name}>
                  Enable Email To Support Executive For Test Drive?
                </label>
              </Fragment>
            )}
          />
          <ErrorMessage>
            {errors.enableCCEmailToCrmAgentForTestDrive?.message}
          </ErrorMessage>
        </div>
      </div>
    );
  };

  const renderEnableCCEmailToCrmAgentForShowroomVisit = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <Controller
            control={control}
            name="enableCCEmailToCrmAgentForShowroomVisit"
            defaultValue={props.data?.enableCCEmailToCrmAgentForShowroomVisit}
            render={({ onChange, value, name }) => (
              <Fragment>
                <input
                  type="checkbox"
                  id={name}
                  checked={value}
                  onChange={(e) => onChange(e.target.checked)}
                />
                <label htmlFor={name}>
                  Enable Email To Support Executive For Showroom
                  Visit?
                </label>
              </Fragment>
            )}
          />
          <ErrorMessage>
            {errors.enableCCEmailToCrmAgentForShowroomVisit?.message}
          </ErrorMessage>
        </div>
      </div>
    );
  };

  const renderConvertedToEnquiryEmailSmsRecipientsUserTypes = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">
          Converted To Opportunity Email/Sms Recipient UserTypes
        </label>
        <div className="row">
          <div className="col-12">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                name="convertedToEnquiryEmailSmsRecipientsUserTypes"
                defaultValue={
                  props.data?.convertedToEnquiryEmailSmsRecipientsUserTypes
                }
                render={({ onChange, value, name }) => (
                  <Multiselect
                    value={value}
                    data={Object.keys(AccountType).map((key) => {
                      return {
                        label: convertPascalCaseToWords(
                          key === "CallCenterExecutive"
                            ? "BusinessDeveloperExecutive"
                            : key === "Agent"
                            ? "TransactionExecutive"
                            : key
                        ),
                        value: key,
                      };
                    })}
                    defaultValue={value}
                    textField={"label"}
                    valueField={"value"}
                    placeholder={"Select User Type"}
                    onChange={(val) => {
                      onChange(val?.map((x) => x.value));
                    }}
                    allowCreate="onFilter"
                    autoFocus={true}
                  />
                )}
              />
              {errors.convertedToEnquiryEmailSmsRecipientsUserTypes && (
                <ErrorMessage>User Type is required</ErrorMessage>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderCampaignEmailRecipientsUserTypes = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">
          Campaign Discount Approval Email Recipient UserType
        </label>
        <div className="row">
          <div className="col-12">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                name="campaignEmailRecipientsUserType"
                defaultValue={props.data?.campaignEmailRecipientsUserType}
                render={({ onChange, value, name }) => (
                  <DropdownList
                    value={value}
                    data={Object.keys(AccountType).map((key) => {
                      return {
                        label: convertPascalCaseToWords(key),
                        value: key,
                      };
                    })}
                    defaultValue={value}
                    textField={"label"}
                    valueField={"value"}
                    placeholder={"Select User Type"}
                    onChange={(val) => {
                      onChange(val.value);
                    }}
                    allowCreate="onFilter"
                    autoFocus={true}
                  />
                )}
              />
              {errors.campaignEmailRecipientsUserType && (
                <ErrorMessage>User Type is required</ErrorMessage>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderAppoinmentReminderTriggerInMinutes = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">
            Appoinment Reminder Trigger In Minutes
          </label>
          <Controller
            control={control}
            rules={{
              validate: {
                numberOnly: (value) =>
                  new RegExp("\\d+").test(value) || "Invalid value",
                min: (value) => Number(value) >= 0 || "Value shoud be positive",
              },
            }}
            name="appoinmentReminderTriggerInMinutes"
            defaultValue={
              props.data?.appoinmentReminderTriggerInMinutes || 1440
            }
            render={({ onChange, value, name }) => (
              <input
                type="number"
                min={0}
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Appoinment Reminder Trigger In Minutes"
                name={name}
                value={value}
                onChange={onChange}
                id="appoinmentReminder"
              />
            )}
          />
        </div>
      </div>
    );
  };
  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            Update
          </button>
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">
          Update Notification Settings
        </h4>
        <div className="row gutter-10">
          {renderSmsEnabledTemplates()}
          {/* {renderAppNotificationEnabledTemplates()} */}
          {renderEmailEnabledTemplates()}
          {renderCcEnabledEvents()}
          {renderEnableCCEmailToCrmAgentForAssignSalesPerson()}
          {/* {renderEnableCCEmailToCrmAgentForTestDrive()} */}
          {renderEnableCCEmailToCrmAgentForShowroomVisit()}
          {renderAppoinmentReminderTriggerInMinutes()}
          {renderConvertedToEnquiryEmailSmsRecipientsUserTypes()}
          {/* {renderCampaignEmailRecipientsUserTypes()} */}
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
        </div>
      </div>
    </form>
  );
};

export default UpdateForm;
